import { useLocation, useNavigate } from "react-router-dom";
import { FF } from "../shared";

const NAV = [
  {
    path: "/campaigns",
    label: "Campaigns",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2L2 7l10 5 10-5-10-5z"/>
        <path d="M2 17l10 5 10-5"/>
        <path d="M2 12l10 5 10-5"/>
      </svg>
    ),
  },
  {
    path: "/invoices",
    label: "Invoices",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
        <polyline points="14,2 14,8 20,8"/>
        <line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/>
      </svg>
    ),
  },
  {
    path: "/cashflow",
    label: "Cash Flow",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="20" x2="18" y2="10"/>
        <line x1="12" y1="20" x2="12" y2="4"/>
        <line x1="6"  y1="20" x2="6"  y2="14"/>
      </svg>
    ),
  },
  {
    path: "/remittances",
    label: "Remittances",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="5" width="20" height="14" rx="2"/>
        <line x1="2" y1="10" x2="22" y2="10"/>
      </svg>
    ),
  },
];

const FUTURE = [
  { label: "Dashboard", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg> },
  { label: "Expenses",  icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg> },
  { label: "Reports",   icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg> },
  { label: "Settings",  icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg> },
];

function useNav() {
  const location = useLocation();
  const navigate = useNavigate();
  return { location, navigate };
}

export default function Sidebar() {
  const { location, navigate } = useNav();

  return (
    <div
      style={{
        width: 220,
        minWidth: 220,
        height: "100%",
        background: "rgba(255,255,255,0.55)",
        backdropFilter: "blur(40px) saturate(180%)",
        WebkitBackdropFilter: "blur(40px) saturate(180%)",
        border: "0.5px solid rgba(255,255,255,0.7)",
        borderRadius: 18,
        display: "flex",
        flexDirection: "column",
        zIndex: 10,
        flexShrink: 0,
        overflow: "hidden",
      }}
    >
      {/* Brand mark */}
      <div style={{ padding: "24px 20px 18px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{
            width: 32, height: 32, borderRadius: 9,
            background: "rgba(255,255,255,0.6)",
            border: "0.5px solid rgba(255,255,255,0.88)",
            display: "flex", alignItems: "center", justifyContent: "center",
            flexShrink: 0,
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
                stroke="rgba(50,60,90,0.65)" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#1c1c1e", letterSpacing: "-0.3px", fontFamily: FF }}>
              QC Inc.
            </div>
            <div style={{ fontSize: 10, color: "rgba(60,60,67,0.38)", fontFamily: FF, marginTop: 1 }}>
              Business Manager
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div style={{ height: "0.5px", background: "rgba(255,255,255,0.6)", margin: "0 14px 4px" }} />

      {/* Active nav items */}
      <nav style={{ padding: "8px 10px", flex: 1 }}>
        <div style={{ fontSize: 10, fontWeight: 600, color: "rgba(60,60,67,0.3)", letterSpacing: "0.8px", textTransform: "uppercase", padding: "6px 10px 8px", fontFamily: FF }}>
          Workspace
        </div>
        {NAV.map((item) => {
          const active = location.pathname === item.path || (location.pathname === "/" && item.path === "/campaigns");
          return (
            <button
              key={item.path}
              className="nav-item"
              onClick={() => navigate(item.path)}
              style={{
                display: "flex", alignItems: "center", gap: 9,
                width: "100%", padding: "8px 10px", borderRadius: 9,
                border: active ? "0.5px solid rgba(255,255,255,0.85)" : "0.5px solid transparent",
                background: active ? "rgba(255,255,255,0.62)" : "transparent",
                color: active ? "#1c1c1e" : "rgba(60,60,67,0.48)",
                cursor: "pointer",
                fontSize: 13.5,
                fontWeight: active ? 600 : 400,
                transition: "background 0.15s,color 0.15s",
                marginBottom: 2,
                fontFamily: FF,
                textAlign: "left",
              }}
            >
              <span style={{ opacity: active ? 0.75 : 0.4, flexShrink: 0 }}>{item.icon}</span>
              {item.label}
              {active && (
                <div style={{
                  width: 5, height: 5, borderRadius: "50%",
                  background: "rgba(50,65,120,0.35)",
                  marginLeft: "auto", flexShrink: 0,
                }} />
              )}
            </button>
          );
        })}

        {/* Coming soon */}
        <div style={{ height: "0.5px", background: "rgba(255,255,255,0.55)", margin: "10px 0" }} />
        <div style={{ fontSize: 10, fontWeight: 600, color: "rgba(60,60,67,0.22)", letterSpacing: "0.8px", textTransform: "uppercase", padding: "6px 10px 8px", fontFamily: FF }}>
          Coming Soon
        </div>
        {FUTURE.map((item) => (
          <div
            key={item.label}
            style={{
              display: "flex", alignItems: "center", gap: 9,
              padding: "8px 10px", borderRadius: 9,
              color: "rgba(60,60,67,0.22)",
              fontSize: 13.5, fontWeight: 400, marginBottom: 2,
              fontFamily: FF, cursor: "default", userSelect: "none",
            }}
          >
            <span style={{ opacity: 0.35, flexShrink: 0 }}>{item.icon}</span>
            {item.label}
          </div>
        ))}
      </nav>

      {/* Footer */}
      <div style={{ padding: "10px 16px 20px", borderTop: "0.5px solid rgba(255,255,255,0.55)" }}>
        <div style={{ fontSize: 10, color: "rgba(60,60,67,0.25)", fontFamily: FF, lineHeight: 1.6 }}>
          9456-1438 Québec inc.
          <br />
          FY2026 · Oct → Jul
        </div>
      </div>
    </div>
  );
}

// Mobile bottom tab bar
export function MobileNav() {
  const { location, navigate } = useNav();

  return (
    <div
      className="mobile-nav"
      style={{
        position: "fixed",
        bottom: 0, left: 0, right: 0,
        height: 72,
        background: "rgba(255,255,255,0.58)",
        backdropFilter: "blur(40px) saturate(180%)",
        WebkitBackdropFilter: "blur(40px) saturate(180%)",
        borderTop: "0.5px solid rgba(255,255,255,0.75)",
        alignItems: "center",
        justifyContent: "space-around",
        zIndex: 100,
        paddingBottom: "env(safe-area-inset-bottom, 0px)",
      }}
    >
      {NAV.map((item) => {
        const active = location.pathname === item.path || (location.pathname === "/" && item.path === "/campaigns");
        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            style={{
              flex: 1, height: "100%",
              background: "none", border: "none",
              display: "flex", flexDirection: "column",
              alignItems: "center", justifyContent: "center",
              gap: 4,
              color: active ? "#1c1c1e" : "rgba(60,60,67,0.38)",
              cursor: "pointer", fontFamily: FF,
            }}
          >
            <span style={{ opacity: active ? 0.8 : 0.38 }}>{item.icon}</span>
            <span style={{ fontSize: 10, fontWeight: active ? 600 : 400, letterSpacing: "0.1px" }}>
              {item.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
